<template>

  <div>

    <transition
      name="fade">
      <div
        v-if="bgShow"
        class="modal-bg"></div>
    </transition>

    <transition
      name="slideTop">
      <div
        v-if="modalShow"
        class="modal-block"
        @click.self="$emit('close')">
        <div
          class="modal-block__content">

          <slot />

        </div>
      </div>
    </transition>

  </div>

</template>

<script>
export default {
  props: ['bgShow', 'modalShow'],
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/modal-layout.sass'
</style>
